import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorFillTypeFromFillType, getColorObjectArrayFromFillColor, getFillTypeFromColorFillType} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {ColorFillPropertyType} from '@Components/color-fill';
import type {FillObject, FillTypes} from '@PosterWhiteboard/classes/fill.class';

interface BaseTextFillColorPanelProps {
  fillObject: FillObject;
  onUpdateColor(updatedColor: RGBA[], undoable?: boolean): void;
  onChangeType?(newType: FillTypes): void;
  isForLayoutItem?: boolean;
}

export function BaseTextFillColorPanel({onChangeType = (): void => {}, isForLayoutItem = false, ...props}: BaseTextFillColorPanelProps): ReactElement<any> {
  const updateFillColor = (fillColor: RGBA[], undoable = true): void => {
    props.onUpdateColor(fillColor, undoable);
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    updateFillColor(getRGBAArrayFromColorStorage(updatedColor), false);
  };

  const onChangeEnded = (updatedColor: ColorStorage[]): void => {
    updateFillColor(getRGBAArrayFromColorStorage(updatedColor));
  };

  const onChangeTypeCallback = (newType: ColorFillPropertyType): void => {
    if (getFillTypeFromColorFillType(newType) === props.fillObject.fillType) {
      return;
    }
    onChangeType(getFillTypeFromColorFillType(newType));
  };

  return (
    <PosterEditingBaseColorPanel
      id="text-fill-color-panel"
      color={getColorObjectArrayFromFillColor(props.fillObject.fillColor)}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeEnded}
      onChangeType={onChangeTypeCallback}
      isGradientEnabled={!isForLayoutItem}
      type={getColorFillTypeFromFillType(props.fillObject.fillType)}
    />
  );
}
